import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
	palette: {
		primary: {
			light: "#79637d",
			main: "#4d3951",
			dark: "#241329",
			contrastText: "#fff",
		},
		secondary: {
			light: "#69eac3",
			main: "#2bb793",
			dark: "#008665",
			contrastText: "#fff",
		},
	},
});

export default theme;
